import { Capacitor } from '@capacitor/core';

// AJ1 · Märken som länkar till App Store / Google Play. Länkarna sätts i VITE_APP_STORE_URL och
// VITE_PLAY_STORE_URL; tills en app är publicerad är variabeln tom och märket visas inte.
// Märkena döljs inne i apparna. SVG-filerna i public/badges ska bytas mot Apples och Googles
// officiella märken (marknadsföringsverktygen) innan de används skarpt.

export interface StoreLinks { appStore: string; playStore: string }

export const STORE_LINKS: StoreLinks = {
  appStore: ((import.meta.env.VITE_APP_STORE_URL as string | undefined) ?? '').trim(),
  playStore: ((import.meta.env.VITE_PLAY_STORE_URL as string | undefined) ?? '').trim(),
};

type Store = 'ios' | 'android';
export type BadgeEntry = { store: Store; href: string };

function isHttpUrl(u: string): boolean { return /^https:\/\//i.test(u); }

/** Vilka märken som ska visas och i vilken ordning. Android-enheter får Play först, övriga App Store först. */
export function badgeEntries(links: StoreLinks, userAgent: string): BadgeEntry[] {
  const android = /android/i.test(userAgent);
  const all: BadgeEntry[] = [
    { store: 'ios', href: links.appStore },
    { store: 'android', href: links.playStore },
  ];
  const shown = all.filter(b => isHttpUrl(b.href));
  return android ? shown.reverse() : shown;
}

function insideApp(): boolean {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
}

export function AppBadges({ links = STORE_LINKS, userAgent, native }: { links?: StoreLinks; userAgent?: string; native?: boolean }) {
  const hidden = native ?? insideApp();
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const entries = hidden ? [] : badgeEntries(links, ua);
  if (!entries.length) return null;
  return (
    <div data-testid="app-badges" style={{ marginTop: 20, textAlign: 'center' }}>
      <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 8 }}>Ladda ner Qvenari</div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
        {entries.map(b => (
          <a key={b.store} href={b.href} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', lineHeight: 0 }}>
            <img src={b.store === 'ios' ? '/badges/app-store-sv.svg' : '/badges/google-play-sv.svg'} height={40}
              alt={b.store === 'ios' ? 'Ladda ner från App Store' : 'Hämta på Google Play'} style={{ height: 40, width: 'auto' }} />
          </a>
        ))}
      </div>
    </div>
  );
}
